<template>
  <div>
    <a
      class="shop-btn"
      :lang="lang"
      :style="{ backgroundImage: `url(${langMap[lang].bg || enBg})` }"
      href="https://shop.bekko.com/sengoku/"
      target="_blank"
    >
      <img :src="langMap[lang].sale || enBg1" />
    </a>
  </div>
</template>

<script>
import enBg from "@/assets/imgs/shopbtns/EN.png";
import enBg1 from "@/assets/imgs/shopbtns/EN1.png";
import jpBg from "@/assets/imgs/shopbtns/JP.png";
import jpBg1 from "@/assets/imgs/shopbtns/JP1.png";
import thBg from "@/assets/imgs/shopbtns/TH.png";
import thBg1 from "@/assets/imgs/shopbtns/TH1.png";
import twBg from "@/assets/imgs/shopbtns/TW.png";
import twBg1 from "@/assets/imgs/shopbtns/TW1.png";

export default {
  props: {
    lang: {
      type: String,
      default: "zh-CN" // en, ja, th, zh-CN
    }
  },
  data() {
    return {
      // cdnPrefix: "https://cdn-os-web.jedi-games.com/gw/games/sengoku/static",
      cdnPrefix: "../assets",
      langMap: {
        "zh-CN": { bg: twBg, sale: twBg1 },
        ja: { bg: jpBg, sale: jpBg1 },
        th: { bg: thBg, sale: thBg1 },
        en: { bg: enBg, sale: enBg1 }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.shop-btn {
  display: block;
  width: 140px;
  height: 70px;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 140px;
  cursor: pointer;
  position: relative;
  img {
    position: absolute;
    left: 0;
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShopButton.vue